/**
 * Product Card Cached Selection Fix
 * On page load, sync images with any browser-cached checked inputs
 * This runs regardless of color sync settings to fix browser form restoration
 */
(() => {
  function syncCachedSelections() {
    const productCards = document.querySelectorAll('product-card');
    
    productCards.forEach((card) => {
      const checkedInput = card.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        // Trigger change to update the image to match the cached selection
        checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  
  // Run on DOM ready to handle browser-cached selections
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCachedSelections);
  } else {
    // DOM already loaded, run immediately
    syncCachedSelections();
  }
})();
